import { Input } from '@/components/ui/input'
import { MODULES, useModules } from '@/hooks/useModules'
import { OrganizationCategorySelect } from './OrganizationCategorySelect'
import type { CategoryChoice } from './category-choice'

interface LineCategoryFieldProps {
  id: string
  projectId: string
  value: CategoryChoice
  onChange: (value: CategoryChoice) => void
  /** Labels already used on the other lines, offered while typing a free label. */
  suggestions: readonly string[]
  placeholder: string
}

/**
 * The category of a hand-typed line (direct sale, free invoice). With quote_import, one of the
 * organisation's categories (S07b); without it, the free label with suggestions that prod has
 * always had (SOLY-IMPORT-003 S19).
 */
export function LineCategoryField({ id, projectId, value, onChange, suggestions, placeholder }: LineCategoryFieldProps) {
  const { hasModule } = useModules()

  if (hasModule(MODULES.QUOTE_IMPORT)) {
    return <OrganizationCategorySelect id={id} projectId={projectId} value={value} onChange={onChange} />
  }

  const listId = `${id}-suggestions`
  return (
    <>
      <Input
        id={id}
        data-testid="line-category-input"
        list={listId}
        placeholder={placeholder}
        value={value.categoryLabel ?? ''}
        onChange={(e) => onChange({ categoryId: null, categoryLabel: e.target.value })}
      />
      <datalist id={listId}>
        {suggestions.map((label) => (
          <option key={label} value={label} />
        ))}
      </datalist>
    </>
  )
}
